import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=4ee5b96a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee5b96a')) {
      api.createRecord('4ee5b96a', component.options)
    } else {
      api.reload('4ee5b96a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=4ee5b96a&", function () {
      api.rerender('4ee5b96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/imageCarousel.vue"
export default component.exports